import { MouseEventHandler, RefObject } from 'react'
import { List, ListItem, ListItemButton, ListItemText, Paper, Popover } from '@mui/material'

export interface IMoreTableItem {
  label: string
  onClick: MouseEventHandler
  isDisabled?: boolean
}

interface IMorePopoverProps {
  anchorRef: RefObject<HTMLButtonElement>
  open: boolean
  handleClose: MouseEventHandler
  items: IMoreTableItem[]
}

const MorePopover = ({ anchorRef, handleClose, open, items }: IMorePopoverProps) => {
  const handleClick =
    (func: Function): MouseEventHandler =>
    (e) => {
      handleClose(e)
      func(e)
    }

  return (
    <Popover
      open={open}
      anchorEl={anchorRef.current}
      onClose={handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <Paper>
        <List disablePadding>
          {items.map(({ label, onClick, isDisabled }) => (
            <ListItem key={label} disablePadding>
              <ListItemButton disabled={isDisabled} onClick={handleClick(onClick)}>
                <ListItemText primary={label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>
    </Popover>
  )
}

export { MorePopover }
